import { render, staticRenderFns } from "./LivingImagesViewer.vue?vue&type=template&id=5163b924&"
import script from "./LivingImagesViewer.vue?vue&type=script&lang=js&"
export * from "./LivingImagesViewer.vue?vue&type=script&lang=js&"
import style0 from "./LivingImagesViewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports